<template>
  <div class="space-y-6">
    <div class="flex flex-col w-full mb-4">
      <label class="font-semibold text-sm text-grey-700 mb-2">
        {{ $t('frontend_groovemember_files_name') }}
      </label>
      <text-input
        v-model="upload_file.name"
        :validator="$v.upload_file.name"
        :attribute="'Name'"
        :placeholder="$t('frontend_groovemember_files_name')"
      />
    </div>
    <div class="flex flex-col w-full mb-4">
      <label class="font-semibold text-sm text-grey-700 mb-2"> Url </label>
      <text-input
        v-model="upload_file.url"
        :validator="$v.upload_file.url"
        :attribute="'Url'"
        :placeholder="'Url'"
      />
    </div>
    <gd-button
      class="text-center w-40 mt-5"
      size="large"
      primary
      @click="uploadFilesToServer"
    >
      Add File
    </gd-button>
  </div>
</template>
<script>
import { required, minLength, maxLength, url } from 'vuelidate/lib/validators';
export default {
  name: 'ExternalUrl',
  data() {
    return {
      upload_file: {
        name: '',
        url: '',
      },
    };
  },
  validations: {
    upload_file: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(160),
      },
      url: {
        required,
        url,
      },
    },
  },
  methods: {
    uploadFilesToServer() {
      try {
        this.$v.$touch();
        if (this.$v.upload_file.$invalid) {
          throw new Error('Invalid Data');
        }
        this.$emit('selected', {
          id: 0,
          name: this.upload_file.name,
          original_name: this.upload_file.name,
          size: '',
          actual_size: '',
          downloads: 0,
          secure_link: this.upload_file.url,
          mime_type: '',
          new_download_link: this.upload_file.url,
          category_id: 1,
          category_name: 'Default Category',
          public_path: this.upload_file.url,
        });
      } catch (err) {
        /** */
      }
    },
  },
};
</script>